













import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import EditField from './edit-field.vue';
import NotEditField from './not-edit-field.vue';
import { i18n } from './../../../../i18n';
import { TranslateResult } from 'vue-i18n';

const name = 'ttam-image-settings-field';
export default defineComponent({
  name,
  components: {
    EditField,
    NotEditField,
  },
  props: {
    options: {
      type: Array as PropType<{ label: string; value: number; disabled?: boolean }[]>,
      required: true,
    },
    label: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    tooltip: {
      type: String as PropType<string | TranslateResult>,
      default: '',
    },
    value: {
      type: Number,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value, options } = toRefs(props);
    const text = computed(() => {
      const currentOpt = options.value.find(it => it.value === value.value);
      return i18n.t(currentOpt.label);
    });

    const handleChange = (val: KeyType) => {
      emit('input', val);
    };

    return {
      name,
      handleChange,
      text,
    };
  },
});
